<template>
  <div>
    <span class="font-weight-bold">Tipo composição:</span> {{ item.typeComposition }} - {{ typeCompositionLabel }}

    <b-card-body>
      <div class="row mx-md-n3 mx-1">
        <b-col sm="12">
          <div v-if="itemLoadingComposition" class="mb-5 pb-5">
            <loading-animation />
          </div>

          <div v-if="!itemLoadingComposition && !itemCompositions.length" class="mb-3">
            <div class="row bg-light mx-0 py-3">
              <div class="col text-center">
                Este item não possui nenhuma composição
              </div>
            </div>
          </div>

          <div v-if="!itemLoadingComposition && itemCompositions.length" class="mb-3">
            <div v-for="(item, index) in itemCompositions" class="row py-3 border mx-0" :key="index"
              :class="{ 'bg-light': index % 2 != 0 }">
              <div class="col-xl-9 col-lg-8 col-md-8 col-sm-8 col-6">
                  <span class="font-weight-bold">Item componente: </span>{{item.compositionItem ? getItemReduzidoFromRef(item.compositionItem.ref): ''}}
                  - {{item.compositionItem ? item.compositionItem.description : ''}}
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-6">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold">Quantidade: </span>{{item.quantity}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </div>
    </b-card-body>
  </div>
</template>

<script>
  import { httpClient } from '@/service';
  import { LoadingAnimation } from '@/components/loaders'

  export default {
    name: 'item-composition',
    components: {
      LoadingAnimation
    },

    props: {
      item: {
        type: Object,
        required: true
      },
      getItemReduzidoFromRef: {
        type: Function,
        required: true
      }
    },

    data () {
      return {
        itemLoadingComposition: false,
        itemCompositions: [],
        itemCompositionSearched: false
      }
    },

    computed: {
      typeCompositionLabel() {
        if (!this.item.typeComposition) {
          return "Em branco";
        }

        switch (this.item.typeComposition) {
          case "K": return "Item Kit"
          case "M": return "Item Mestre"
          case "N": return "Sem Composição"
          case "P": return "Item Produção"
          case "D": return "Desmembramento"

          default: return " "
        }

      },
    },

    methods: {
      tabChanged() {
        if (!this.itemCompositionSearched) {
          this.searchItemCompositions();
          this.itemCompositionSearched = true;
        }
      },

      searchItemCompositions() {
        if(!this.itemLoadingComposition) {
          this.itemLoadingComposition = true

          let condition = [
            {
              field: 'deletedAt',
              conditionalOperator: 'IS_NULL'
            },
            {
              field: 'itemId',
              conditionalOperator: 'EQUALS',
              value: this.item.id,
            }
          ];

          httpClient
          .post(`${process.env.VUE_APP_API_URL}item-compositions/condition?page=${0}&size=${1000}`, {
            conditions: condition
          })
          .then(({ data }) => {
            this.itemCompositions = data.data.content;
            this.itemLoadingComposition = false
          })
          .catch((error) => {
            if (error.message) {
              this.$notify.error(error)
            }
            this.itemCompositions = [];
            this.itemLoadingComposition = false
          });
        }
      },
    }
  }
</script>

<style scoped>
</style>
